// extracted by mini-css-extract-plugin
export default {"container":"AccountSettings_container__QfoSQ","contentBlock":"AccountSettings_contentBlock__foPyJ"};